module.exports = __webpack_public_path__ + "img/logo28.f9dc501e.png";